import { firestore } from "../../config/firebase";
import { doc, updateDoc } from "firebase/firestore";

const updateInvestment = async (id, obj) => {
  const investmentRef = doc(firestore, "investments", id);
  await updateDoc(investmentRef, obj);
};

export default updateInvestment;